import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type { PhoneQuotaInfo } from "../types";

export function usePhoneQuota() {
  return useQuery<PhoneQuotaInfo>({
    queryKey: ["trustcall", "phones", "quota"],
    queryFn: () => callApi(TC.PHONES_QUOTA, HttpMethod.GET),
    staleTime: 60_000, // 1 minute
  });
}
